import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'MainEstimacionesReportesConcentrado',
  mixins: [mixGenerarPdf, mixFormatoEstructura],
  data() {
    return {};
  },
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfConcentrado() {
      this.$emit('generando');
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${this.estimacion.fechaPresentacion} 00:00:0`, this.firmas);

      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const listadoConcentradoConFormato = this.formatoObjeto(this.listadoConcentrado);
      const supervisor = this.getSupervisorEnConcentrado || '';
      const supervisionExterna = this.getContratoSupervisionExternaEnConcentrado
        ?.contratoRelacionado
        ?.contratista?.nombreRazonSocial || '';
      const firmasFuncionarios = encabezadoReferencia.firmas || [];
      const fechaActual = this.formatoFechaActual();
      let nombreTemplate = 'templateConcentrado';
      if (this.contrato.esObraFinanciada) { nombreTemplate = 'templateConcentradoOPF'; }
      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato: contratoConFormato,
          estimacion: estimacionConFormato,
          trabajos: listadoConcentradoConFormato,
          supervisor,
          supervisionExterna,
          firmas: firmasFuncionarios,
          fechaActual,
          footer: '',
          encabezadoReferencia,
        },
      }, `${this.contrato.numero}_Concentrado_Estimacion_${this.estimacion.numero}`);
      this.$emit('terminando');
    },
  },
  computed: {
    conceptosConLosExcedentes() {
      return this.estimacion
        .conceptos
        .map((concepto) => {
          let existeExcedente = false;
          const { cantidad } = concepto;
          const cantidadContratada = concepto.concepto.cantidad;
          const cantidadEstimada = this.$numberRoundDigits(concepto.concepto.estimado
            .filter((estimado) => estimado.estimacion.numero < this.estimacion.numero)
            .reduce((v, estimacion) => v + (estimacion.cantidad), 0), 5);
          const cantidadEstimadaActual = cantidadEstimada + cantidad;
          let cantidadExcedente = 0;
          let importeExcedente = 0;

          if (cantidadContratada > 0 && cantidadEstimadaActual > cantidadContratada) {
            existeExcedente = true;
            const diferencia = cantidadEstimadaActual - cantidadContratada;
            cantidadExcedente = diferencia;

            if (diferencia > cantidad) {
              cantidadExcedente = cantidad;
            }

            importeExcedente = this.$numberRound((
              cantidadExcedente * concepto.concepto.precioUnitario));
          }

          return {
            ...concepto,
            cantidadExcedente,
            importeExcedente,
            existeExcedente,
          };
        });
    },
    listadoConcentrado() {
      if (!this.conceptosConLosExcedentes) return [];
      // Listado de conceptos normales
      const conceptosNormales = this.conceptosConLosExcedentes
        .filter(({ concepto }) => concepto.cantidad > 0);
      // Listado de conceptos con excedente
      const conceptosConExcedentes = this.conceptosConLosExcedentes
        .filter((concepto) => concepto.existeExcedente === true);
      // Listado de conceptos FPs
      const conceptosFps = this.conceptosConLosExcedentes
        .filter(({ concepto }) => concepto.cantidad === 0);

      // Regresar el listado
      return [
        {
          orden: 1,
          concepto: 'OBRA NORMAL',
          importe: (this.$ObjSumar(conceptosNormales, 'importe')
          - this.$ObjSumar(conceptosConExcedentes, 'importeExcedente')),
          observaciones: '',
        },
        {
          orden: 2,
          concepto: 'OBRA EXCEDENTE',
          importe: this.$ObjSumar(conceptosConExcedentes, 'importeExcedente'),
          observaciones: '',
        },
        {
          orden: 3,
          concepto: 'OBRA FUERA DE PRESUPUESTO',
          importe: this.$ObjSumar(conceptosFps, 'importe'),
          observaciones: '',
        },
      ].filter((concepto) => concepto.importe > 0 || concepto.importe < 0);
    },
    getSupervisorEnConcentrado() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoSupervisionExternaEnConcentrado() {
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
  },
};
